module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Ki-Lb.5f162088.png";